import { prop } from '@lib/style/theme';
import { cleanProps } from '@lib/utils';
import { CSSProperties } from 'react';
import { css } from 'styled-components';

export interface OverflowProps {
    o: CSSProperties['overflow'];
    overflow: CSSProperties['overflow'];
}

export const overflow = (defaultValue?: OverflowProps['overflow']): any => css`
    & {
        overflow: ${prop(['o', 'overflow'], defaultValue)};
    }
`;

overflow.clean = (props): any => cleanProps(props, ['o', 'overflow']);
